export function readFormDraft<T extends object>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? ({...fallback, ...parsed} as T)
      : fallback;
  } catch {
    return fallback;
  }
}

export function writeFormDraft<T extends object>(key: string, value: T) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* Storage can be unavailable in private mode or under strict browser policies. */
  }
}

export function clearFormDraft(key: string) {
  try {
    localStorage.removeItem(key);
  } catch {
    /* Storage can be unavailable in private mode or under strict browser policies. */
  }
}

export function sameFormValue<T>(left: T, right: T) {
  return JSON.stringify(left) === JSON.stringify(right);
}
